import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import StatusHeader from 'components/common/StatusHeader';
import { CONST_DEL_GENRE_FILTER } from 'features/Genre/constans';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Genre, Sortable } from '../../models/Genre';
import './List.scss';
import Filter from './components/Filter';
import TableList from './components/TableList';
import service from './services';

function List() {
  const { t } = useTranslation();
  const history = useHistory();
  const [nameGenre, setNameGenre] = useState('');
  const [dataTable, setDataTable] = useState<Genre[] | []>();
  const [sort, setSort] = useState<Sortable>({ name: 0, note: 0 });
  const [deleteFlg, setDeleteFlg] = useState(CONST_DEL_GENRE_FILTER.HIDE_DEL);

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  // call API
  async function filterAPI(name: string) {
    await service
      .getGenres(name, deleteFlg)
      .then((result) => {
        setDataTable(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // first load page
  useEffect(() => {
    async function getDataTable(name: string) {
      filterAPI(name);
    }
    getDataTable(nameGenre);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  // search name
  function handleFilter() {
    filterAPI(nameGenre);
  }

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <StatusHeader onAction={() => history.push('/')} />
      </div>
      <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
        <div className="page-content store-setting-page d-flex flex-column">
          <div className="mb-3">
            <FeatureTitleBar title={t('Genre.Title')}></FeatureTitleBar>
          </div>

          <div className="mb-3">
            <Filter
              setName={setNameGenre}
              name={nameGenre}
              deleteFlg={deleteFlg}
              handleFilter={handleFilter}
              setDeleteFlg={setDeleteFlg}
            ></Filter>
          </div>

          {dataTable && (
            <TableList dataTable={dataTable} setSort={setSort} sort={sort} setDataTable={setDataTable}></TableList>
          )}
        </div>
      </div>
    </div>
  );
}
export default List;
